import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { LinearProgress } from '@mui/material';
import { useDispatch } from 'react-redux';
import { setSidebarScreen } from '../../../store/sidebar/actions';
import LeftArrowIcon from '../../common/Icons/LeftArrowIcon';
import SearchIcon from '../../common/Icons/SearchIcon';
import {
    getAllBusinessDisplayUnitList,
    GetAllBusinessDisplayUnitListRequestPayload,
    GetAllBusinessDisplayUnitListResult,
} from '../../../services/business-group.service';
import { BusinessDisplayUnit } from '../../../types/business-group-type';
import ServiceDirectoryBusinessDisplayUnitList from '../ServiceDirectoryBusinessDisplayUnitList/ServiceDirectoryBusinessDisplayUnitList';
import regionConfig from '../../../config';

const StyledDefaultBusinessDirectory = styled.div`
    overflow: scroll;
    .menu-content {
        display: flex;
        align-content: space-between;
        justify-content: space-between;
        padding: 10px;
        padding-left: 20px;
        padding-right: 20px;
        height: 50px;
        width: 100%;
        margin-top: 10px;
    }

    .left-arrow-icon {
        width: 25px;
        height: 25px;
        cursor: pointer;
    }
    .search-icon {
        width: 30px;
        height: 30px;
        cursor: pointer;
    }
    .business-list {
        overflow: auto;
        margin-top: 10px;
        width: 100%;
        min-width: 435px;
        height: calc(100vh - 18rem);
        max-height: 1500px;
    }
    .business-description-content {
        width: 100%;
        height: 100px;
        padding-left: 20px;
        padding-right: 20px;
    }
    .business-description-detail {
        color: #787878;
    }
    .business-description-header {
        font-weight: 700;
        font-size: 30px;
        color: black;
    }
`;

interface DefaultBusinessDirectoryProps {
    launchSearchModal: () => void;
    onSelect: (businessDisplayUnit: BusinessDisplayUnit) => void;
}

const DefaultBusinessDirectory = ({
    launchSearchModal,
    onSelect,
}: DefaultBusinessDirectoryProps) => {
    const [businessDisplayUnitList, setBusinessDisplayUnitList] = useState<BusinessDisplayUnit[]>(
        [],
    );
    const [limit] = useState<number>(30);
    const [offset, setOffset] = useState<number>(0);
    const [totalCount, setTotalCount] = useState<number>(0);
    const [hasMore, setHasMore] = useState<boolean>(true);
    const dispatch = useDispatch();
    const fetchDefaultBusinessList = async () => {
        const payLoad: GetAllBusinessDisplayUnitListRequestPayload = {
            limit,
            offset,
        };
        const result: GetAllBusinessDisplayUnitListResult = await getAllBusinessDisplayUnitList(
            payLoad,
        );
        if (result.data) {
            // const List = businessDisplayUnitList.concat(result.data.businessDisplayUnitList);
            const List = [...businessDisplayUnitList, ...result.data.businessDisplayUnitList];
            setBusinessDisplayUnitList(List);
            setTotalCount(result.data.totalCount);
            if (limit * (offset + 1) > result.data.totalCount) {
                setHasMore(false);
            }
        }
    };
    const fetchMoreDefaultBusinessList = (event: any) => {
        const { target } = event;
        if (hasMore && target.scrollHeight - target.scrollTop - target.clientHeight < 1) {
            if (limit * (offset + 1) < totalCount) {
                setOffset(offset + 1);
            } else {
                setHasMore(false);
            }
        }
    };
    useEffect(() => {
        fetchDefaultBusinessList();
    }, [offset]);

    const backToDashboard = () => {
        dispatch(setSidebarScreen('menu'));
    };

    const text = ` Browse a list of ${regionConfig.organizationSpelling}/businesses you can call for free`;

    return (
        <StyledDefaultBusinessDirectory>
            <div className="menu-content">
                <LeftArrowIcon
                    className="left-arrow-icon"
                    onClick={backToDashboard}
                    aria-label="Back from Community Directory"
                />
                <SearchIcon
                    className="search-icon"
                    onClick={launchSearchModal}
                    id="searchLabel"
                    aria-label="Search"
                />
            </div>
            <div className="business-description-content">
                <div className="business-description-header">Community Directory</div>
                <div className="business-description-detail">{text}</div>
            </div>
            <div
                className="business-list"
                onScroll={(e) => {
                    fetchMoreDefaultBusinessList(e);
                }}
                aria-label="Select organization/business you can call for free"
            >
                <ServiceDirectoryBusinessDisplayUnitList
                    onSelect={onSelect}
                    businessDisplayUnitList={businessDisplayUnitList}
                />
                {hasMore && <LinearProgress />}
            </div>
        </StyledDefaultBusinessDirectory>
    );
};

export default DefaultBusinessDirectory;
